import type { Point, BoundingBox } from '../types';

export function getRectFromPoints(points: number[], resolution): BoundingBox {
    const pointsInX = points.filter((element, index) => index % 2 === 0);
    const pointsInY = points.filter((element, index) => index % 2 === 1);
    const minInX = Math.min(...pointsInX);
    const maxInX = Math.max(...pointsInX);
    const minInY = Math.min(...pointsInY);
    const maxInY = Math.max(...pointsInY);

    return {
        x: minInX * resolution.width,
        y: minInY * resolution.height,
        width: (maxInX - minInX) * resolution.width,
        height: (maxInY - minInY) * resolution.height,
    };
}

/**
 * Returns the combined bounding box
 */
export function combineRect(rectangles: BoundingBox[]): BoundingBox {
    const x = Math.min(...rectangles.map((rect) => rect.x));
    const y = Math.min(...rectangles.map((rect) => rect.y));
    const width = Math.max(...rectangles.map((rect) => rect.width));
    const height = Math.max(...rectangles.map((rect) => rect.height));
    return { x, y, width, height };
}

export function getMidPointFromRect(rectangle: BoundingBox): Point {
    const x = rectangle.x + rectangle.width / 2;
    const y = rectangle.y + rectangle.height / 2;
    return { x, y };
}
